export type AcceptanceStatus =
  | "in_progress"
  | "accepted"
  | "rejected"
  | "canceled"
  | "transfer_confirmed"
  | "transfer_completed";

export const statusMap: Record<AcceptanceStatus, string> = {
  in_progress: "미응답",
  accepted: "수용",
  rejected: "미수용",
  canceled: "의뢰 취소",
  transfer_confirmed: "이송 중",
  transfer_completed: "이송 완료",
};

export type KtasLevel = 1 | 2 | 3 | 4 | 5;

export interface InsightTableData {
  requestId: string;
  preKtas: KtasLevel;
  transferTitle: string;
  requestTime: string; // ISO 문자열 (예: "2025-04-21T21:37:04")
  restTime: string | null;
  restDistance: string | null;
  transferStatus: AcceptanceStatus;
  transferManager: string;
}
